import moment from 'moment';

export const formatDateToSimple = (date: string, seperator = '/', format = 'DD/MM/YYYY') => {
  return moment(date, format).format(`DD${seperator}MM${seperator}YY`);
};
